export const HTTP_UNPROCESSABLE_ENTITY = 422
export const HTTP_NOT_FOUND = 404
export const HTTP_FORBIDDEN = 403
export const HTTP_OK = 200
export const HTTP_NO_CONTENT = 204

/**
 * Fetch async
 * 
 * @param {string} url
 * @param {Object} params
 * @return {Promise<Object>} Return the request result or throw ApiError
 */
export async function jsonFetch(url, params = {}) {
    params = {
        credentials: 'same-origin',
        ...params
    }

    const response = await fetch(url, params)
    if (response.status === 204) {
        return null
    }
    const data = await response.json()
    return data
    throw new ApiError(data.data, response.status)
}

/**
 * Représente une erreur d'API
 * 
 * @property {{
 *  violations: {propertyPath: string, message: string}
 * }} data
 */
export class ApiError {
    constructor(data, status) {
        this.data = data
        this.status = status
    }

    // Récupère la liste de violation pour un champs donnée
    violationsFor(field) {
        return this.data.violations.filter(v => v.propertyPath === field).map(v => v.message)
    }

    get name() {
        return `${this.data.title} ${this.data.detail || ''}`
    }

    // Renvoie les violations indexé par propertyPath
    get violations() {
        if (!this.data.violations) {
            return {
                main: `${this.data.title} ${this.data.detail || ''}`
            }
        }
        return this.data.violations.reduce((acc, violation) => {
            if (acc[violation.propertyPath]) {
                acc[violation.propertyPath].push(violation.message)
            } else {
                acc[violation.propertyPath] = [violation.message]
            }
            return acc
        }, {})
    }
}